import React from "react";
import DashboardIcon from "@material-ui/icons/DashboardOutlined";

export default [
  {
    title: "Pages",
    pages: [
      {
        title: "Question",
        href: "/admin/dashboard/question",
        icon: DashboardIcon
      }
    ]
  }
];
